/**
 * Ресурсы Refine — из них строится меню сайдбара и разбираются маршруты.
 *
 * Вынесено из `App.tsx` отдельным модулем, чтобы `MentorSider` можно было
 * проверять тестом на **этом же** списке, а не на копии в фикстуре: иначе тест
 * «ментор видит только ДЗ» ничего не стоит — новый админский раздел появится в
 * App.tsx и останется непокрытым.
 */

import type { ResourceProps } from "@refinedev/core";

export const RESOURCES: ResourceProps[] = [
  {
    name: "dashboard",
    list: "/",
    meta: { label: "Дашборд" },
  },
  {
    name: "leads",
    list: "/leads",
    show: "/leads/:id",
    meta: {
      label: "Лиды",
      canDelete: false,
      dataProviderName: "default",
    },
  },
  {
    name: "broadcasts",
    list: "/broadcasts",
    show: "/broadcasts/:id",
    meta: {
      label: "Уведомления",
      canDelete: false,
      dataProviderName: "default",
    },
  },
  {
    name: "cohorts",
    list: "/cohorts",
    show: "/cohorts/:id",
    meta: {
      label: "Потоки",
      canDelete: false,
      dataProviderName: "default",
    },
  },
  {
    name: "modules",
    list: "/modules",
    edit: "/modules/:id/edit",
    meta: {
      label: "Модули",
      canDelete: false,
      dataProviderName: "default",
    },
  },
  {
    name: "homework",
    list: "/homework",
    show: "/homework/:id",
    meta: {
      label: "ДЗ на проверку",
      canDelete: false,
      dataProviderName: "default",
    },
  },
  {
    name: "service-requests",
    list: "/service-requests",
    meta: {
      label: "Заявки",
      canDelete: false,
      dataProviderName: "default",
    },
  },
  {
    name: "payments",
    list: "/payments",
    meta: {
      label: "Платежи",
      canDelete: false,
      dataProviderName: "default",
    },
  },
  {
    name: "bank-partners",
    list: "/bank-partners",
    meta: {
      label: "Банки-партнёры",
      canDelete: true,
      dataProviderName: "default",
    },
  },
];
